import ahoy from 'ahoy.js';
import mixpanel from 'mixpanel-browser';

import { MIXPANEL_PROJECT_TOKEN } from '@src/env';

import {
  analyticsIdentify,
  analyticsTrack,
  buildAnalyticsConsentPayload,
  extractUserConsent,
  identifyUserTimezone,
} from './application/javascripts/analytics_util';
import createAhoyEvent from './application/javascripts/payments/stripe/analytics';
import trackEvent from './application/javascripts/tracking';
// import files not directly referenced. Most of these setup event handlers or
// call some function that needs to be ran when the pack bundle is loaded.
import './application/javascripts/url/clean-params';
import { dispatchScriptLoadedEvent, ready, sendEventToAhoy } from './application/javascripts/utils';

if (MIXPANEL_PROJECT_TOKEN) {
  mixpanel.init(MIXPANEL_PROJECT_TOKEN, {
    autocapture: true,
    track_pageview: true,
    record_sessions_percent: 100,
    record_heatmap_data: true,
    record_mask_all_text: false,
    record_mask_all_inputs: true,
  });

  window.mixpanel = mixpanel;
  if (typeof currentUser !== 'undefined' && currentUser.id) {
    mixpanel.identify(String(currentUser.id));
  }
  mixpanel.start_session_recording();
}

window.analyticsTrack = analyticsTrack;
window.analyticsIdentify = analyticsIdentify;
window.identifyUserTimezone = identifyUserTimezone;
window.createAhoyEvent = createAhoyEvent;
window.sendEventToAhoy = sendEventToAhoy;
window.buildAnalyticsConsentPayload = buildAnalyticsConsentPayload;
window.trackEvent = trackEvent;
window.extractUserConsent = extractUserConsent;
window.dispatchScriptLoadedEvent = dispatchScriptLoadedEvent;
window.ready = ready;

// These values are the same as above but are also set to be globally available
// within webpack compiled scripts. This is handled in environment.js. They are
// set on the window to satisy any expectations about how they are called.
window.Cookies = Cookies;
window.ahoy = ahoy;
window.$ = $;
